/**
 * Releases: what is going out, who has to agree, and what must be true first.
 *
 * The readiness checklist is computed on the server and sent whole, because the Publish button is
 * only ever as trustworthy as the reasons behind it. A UI that decides for itself whether a
 * release is publishable is a UI that can be wrong in a way nobody notices until production.
 */
export const RELEASE_ITEM_KIND = {
    TASK: 'TASK',
    TICKET: 'TICKET',
    CHANGE_REQUEST: 'CHANGE_REQUEST',
};
export const RELEASE_APPROVAL_DECISION = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
//# sourceMappingURL=releases.js.map